import PropTypes from 'prop-types'
import { pipe, prop, tail } from 'ramda'
import React from 'react'
import urlParse from 'url-parse'

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const getTargetElementId = pipe(urlParse, prop(`hash`), tail)

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

const AnchorLink = ({ to, children, className, title }) => {
  const handleClick = React.useCallback(() => {
    const id = getTargetElementId(to)
    const element = document.getElementById(id)
    if (element) {
      element.scrollIntoView({ behavior: `smooth` })
      document.location.hash = id
    } else {
      throw Error(`[Anchor Link] No element on the page with id: '${id}'`)
    }
  }, [to])

  return (
    <button
      type="button"
      className={className}
      onClick={handleClick}
      title={title}
    >
      {children}
    </button>
  )
}

AnchorLink.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
  title: PropTypes.string,
}

AnchorLink.defaultProps = {
  children: undefined,
  className: undefined,
  title: undefined,
}

export default AnchorLink
